import { useEffect } from 'react';

/**
 * Sets the document title and meta description for the page that calls it.
 * Runs on mount and whenever title/description change, so it re-fires on
 * every route change (each route's component unmounts/mounts in turn).
 */
export function useDocumentMeta(title: string, description: string): void {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', description);
    }
  }, [title, description]);
}
